const rg = /[$()*+.?[\\\]^{|}]/g;

function escapeRegExp(string: string) {
  return string.replaceAll(rg, "\\$&");
}

export const Highlight = ({
  text,
  highlight,
  className,
}: {
  text?: string;
  highlight: string;
  className?: string;
}) => {
  if (!text || text.length === 0) {
    return null;
  }
  if (!highlight || highlight.length === 0) {
    return <span className={className}>{text}</span>;
  }

  const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"));

  return (
    <span className={className}>
      {parts.map((part, i) => {
        if (part.toLowerCase() === highlight.toLowerCase()) {
          return (
            <mark className="bg-alert-yellow" key={i}>
              {part}
            </mark>
          );
        }
        return <span key={i}>{part}</span>;
      })}
    </span>
  );
};
